export default __webpack_public_path__ + "static/media/user-icon.ad8449e9.png";